/* eslint-disable no-undef */
import { makeCarousel } from './component/splide/splide'
import { post } from '../helper/xhrAPI'
import { MenuManager } from './component/front/front-helpers/MenuManager'

const saveButton = document.querySelector('.save-project')
const nbSlides = document.getElementById('thumbnail-slider').dataset.nbslides

const primarySliderConf = {
  pagination: false,
  arrows: nbSlides > 1
}

const secondarySliderConf = {
  arrows: nbSlides > 2,
  fixedWidth: 150,
  gap: 10,
  rewind: true,
  cover: true,
  pagination: false,
  focus: 'center',
  isNavigation: true,
  breakpoints: {
    600: {
      fixedWidth: 66
    }
  }
}

async function createThumbnailCarousel () {
  const secondarySlider = await makeCarousel('#thumbnail-slider', secondarySliderConf)
  makeCarousel('.is-1-item-splide', primarySliderConf).sync(secondarySlider).mount()
}

document.addEventListener('DOMContentLoaded', e => {
  MenuManager()
  // Create carousel
  createThumbnailCarousel()

  // Toggle new project modal
  document.querySelector('button.configurator-trigger').addEventListener('click', e => {
    document.querySelector('.modal.new-project').classList.add('is-active')
    const renameableRooms = document.querySelector('.renameable-room')
    const modalFooter = document.querySelector('.modal-card-foot').getBoundingClientRect()
    if (!renameableRooms || (saveButton.hasAttribute('disabled') && renameableRooms.getBoundingClientRect().bottom < modalFooter.y)) {
      saveButton.removeAttribute('disabled')
    }
    document.body.style.overflow = 'hidden'
    document.querySelector('html').style.overflow = 'hidden'
  })
  document.querySelector('.modal.new-project .close-modal').addEventListener('click', e => {
    document.querySelector('.modal.new-project').classList.remove('is-active')
    document.body.removeAttribute('style')
    document.querySelector('html').removeAttribute('style')
  })

  // save project
  document.querySelector('.modal.new-project .save-project').addEventListener('click', e => {
    e.preventDefault()
    e.target.classList.add('is-loading')
    grecaptcha.ready(function () {
      grecaptcha.execute(`${e.target.getAttribute('data-sitekey')}`, { action: 'submit' }).then(function (token) {
        const data = new FormData()
        data.append('constructionModalConfig', document.querySelector('.modal.new-project input[name="constructionModalConfig"]').value)
        data.append('title', document.querySelector('.modal.new-project .input[name="title"]').value)
        data.append('contributionAmount', document.querySelector('.modal.new-project .input[name="contributionAmount"]').value)
        data.append('loanInterest', document.querySelector('.modal.new-project .input[name="loanInterest"]').value)
        data.append('loanDuration', document.querySelector('.modal.new-project .input[name="loanDuration"]').value)
        data.append('isWithAppointment', document.querySelector('.modal.new-project input[name="isWithAppointment"]').checked ? 1 : 0)
        data.append('g-recaptcha-response', token)
        const rooms = document.querySelectorAll('.modal.new-project .input[name^="room-"]')
        rooms.forEach(room => {
          data.append(room.name, room.value)
        })
        post('/save-project', data, response => {
          if (typeof response.errors === 'undefined') {
            document.querySelector('.modal.new-project').classList.add('validated')
            document.querySelector('.modal.new-project .modal-card-head  .modal-card-title').textContent = response.msg
            if (response.msg) {
              setTimeout(() => {
                window.location.href = response.redirectTo
              }, 2500)
            } else {
              window.location.href = response.redirectTo
            }
          } else {
            createNotification('notification is-danger', '.modal.new-project .modal-card-head .notification.is-danger', document.querySelector('.modal.new-project .modal-card-head'), response.msg)
            for (const prop in response.errors) {
              createNotification(`notification is-danger ${prop}`, `.modal.new-project .modal-card-body .notification.is-danger.${prop}`, document.querySelector(`.modal.new-project .input[name="${prop}"]`).parentElement, response.errors[prop].errors)
            }
          }
          e.target.classList.remove('is-loading')
        })
      })
    })
  })

  // create project modal
  toggleModalActionZone()
})

const createNotification = (cssClass, fullCssClass, parentElement, textContent) => {
  if (document.querySelector(fullCssClass)) {
    document.querySelector(fullCssClass).textContent = textContent
  } else {
    const notification = document.createElement('div')
    notification.className = cssClass
    notification.textContent = textContent
    parentElement.appendChild(notification)
  }
}

/**
 * Toggle modal action zone
 */
const toggleModalActionZone = () => {
  document.querySelector('.modal.new-project .modal-card-body').addEventListener('scroll', e => {
    const renameableRooms = document.querySelector('.renameable-room').getBoundingClientRect()
    const modalFooter = document.querySelector('.modal-card-foot').getBoundingClientRect()
    if (saveButton.hasAttribute('disabled') && renameableRooms.bottom < modalFooter.y) {
      saveButton.removeAttribute('disabled')
    }
    if (!saveButton.hasAttribute('disabled') && renameableRooms.bottom > modalFooter.y) {
      saveButton.setAttribute('disabled', '')
    }
  })

  window.addEventListener('resize', e => {
    const renameableRooms = document.querySelector('.renameable-room').getBoundingClientRect()
    const modalFooter = document.querySelector('.modal-card-foot').getBoundingClientRect()
    if (saveButton.hasAttribute('disabled') && renameableRooms.bottom < modalFooter.y) {
      saveButton.removeAttribute('disabled')
    }
    if (!saveButton.hasAttribute('disabled') && renameableRooms.bottom > modalFooter.y) {
      saveButton.setAttribute('disabled', '')
    }
  })
}
